import useTruckCoordsQuery from "api/queries/common/useTruckCoordsQuery";
import L from "leaflet";
import { useMemo } from "react";
import { Marker, Polyline } from "react-leaflet";

type TruckMarkerItemProps = {
  coords: any;
  marker: string;
  lineColor: string;
};

function TruckMarkerItem({ coords, marker, lineColor }: TruckMarkerItemProps) {
  const coordsString = useMemo(() => {
    if (!coords?.length) {
      return "";
    }
    return coords.map(([lat, lng]: any) => [lng, lat].join(",")).join(";");
  }, [coords]);

  const { data: alignedCoords } = useTruckCoordsQuery(coordsString);

  const coordsToDisplay = alignedCoords || coords;

  if (!coordsToDisplay?.length) {
    return null;
  }

  return (
    <>
      <Marker
        position={[coordsToDisplay.at(-1)[0], coordsToDisplay.at(-1)[1]]}
        icon={L.icon({
          iconUrl: marker,
          iconSize: [25, 41],
        })}
      />
      <Polyline
        positions={[...coordsToDisplay]}
        pathOptions={{
          color: lineColor,
          weight: 2.5, // Line thickness
          // dashArray: "10 10", // Pattern: 10px dash, 10px gap
          lineCap: "round", // Rounded edges for dashes
        }}
      />
    </>
  );
}

export default TruckMarkerItem;
